
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { HisBackendService, HisJobStatus } from 'hisng';

@Injectable()
export class OrcidImportService {

    constructor( private backendService: HisBackendService ) { }

    myOrcidIds(): Observable<string[]> {
        return this.backendService.getData( 'api/v1/fs/res/publication/import/myOrcidIDs' );
    }

    doImportExample(): Observable<any> {
        return this.backendService.getData( 'api/v1/fs/res/publication/import/fromExample' );
        // XXX Das REST-Mapping scheint nicht zu existieren
    }
}
